import {Component, Input, Output, EventEmitter, SimpleChange} from "@angular/core";
@Component({
    selector: 'tab-list',
    templateUrl: './tab-list.component.html',
    styleUrls: ['./tab-list.component.scss']
})
export class TabListComponent {
    @Input() tabs: Array<string>;
    @Input() defaultSelect: number;
    @Output() tabSelected: EventEmitter<any> = new EventEmitter<any>();
    selectedTab: number = 0;

    ngOnChanges(changes: SimpleChange) {
        if (changes['defaultSelect']) {
            this.selectedTab = this.defaultSelect;
        }
    }

    selectTab(index) {
        if (this.selectedTab != index) {
            this.selectedTab = index;
            this.tabSelected.emit(this.selectedTab);
        }
    }
}